import { combineReducers } from "redux";
import profileReducer from "./profileSlice";
import authSlice from "./authSlice";
import themeSlice from "./themeSlice";
import languageSlice from "./languageSlice";

const rootReducer = combineReducers({
  profile: profileReducer,
  authProvider: authSlice,
  themeProvider: themeSlice,
  langProvider: languageSlice,
});

export default rootReducer;
